// src/components/form/fields/FormFieldWrapper.tsx
import React from 'react';
import { Form } from 'antd';
import { useFormikContext } from 'formik';

interface FormFieldWrapperProps {
  name: string;
  label: string;
  required?: boolean;
  children: React.ReactNode;
}

export const FormFieldWrapper: React.FC<FormFieldWrapperProps> = ({ name, label, required, children }) => {
  const { touched, errors } = useFormikContext<any>();

  const error =
    touched[name] && typeof errors[name] === 'string'
      ? (errors[name] as string)
      : undefined;

  return (
    <div className="mb-0">
      <label htmlFor={name} className="block text-sm font-semibold text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <Form.Item validateStatus={error ? 'error' : ''} help={error} className="m-0">
        {children}
      </Form.Item>
    </div>
  );
};
